import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import Box from 'shopper/components/Box';
import Button from 'shopper/components/Button';
import Heading from 'shopper/components/Heading';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import LINKS from 'constants/links';

const ForumSidebarDescription = forwardRef(
  ({ className, gaEventCategory = null }, ref) => {
    const onButtonClick = () => {
      if (gaEventCategory) {
        sendEvent({ category: gaEventCategory, action: 'add_topic_sidebar' });
      }
    };

    return (
      <Box ref={ref} className={twMerge('items-start p-4', className)} full>
        <Heading as="span" size="size5">
          {placeholder('titles.forum')}
        </Heading>
        <Text className="mt-4" size="size2">
          {placeholder('descriptions.whatIsForum')}
        </Text>
        <NextLink href={LINKS.NEW_THREAD} prefetch={false} passHref>
          <Button
            as="a"
            className="mt-4"
            data-test-selector="goto-create-new-thread"
            iconLeft={<Icon name="add-circle-filled" />}
            size="size3"
            onClick={onButtonClick}
          >
            {placeholder('actions.suggestThread')}
          </Button>
        </NextLink>
      </Box>
    );
  }
);

ForumSidebarDescription.displayName = 'ForumSidebarDescription';

ForumSidebarDescription.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  gaEventCategory: PropTypes.string,
};

export default ForumSidebarDescription;
